import React from 'react'
import { ReactComponent as LoadingLogo } from 'Resources/Icons/loading-logo.svg'
import './loading.css'

const Loading = (props) => {
  return <LoadingLogo className={props.size === 'small' ? 'logo-small' : 'logo'} />
}

export default Loading
